import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * El tablero de direccion, que cierra la fase 11.
 *
 * VA EN EL GRUPO DEL ADMINISTRADOR porque todo lo que compone pasa por
 * `app.assert_puede_ver_utilidad`: el resultado del mes, el presupuesto, los eventos y el
 * consolidado que exporta. Una ruta en otro grupo seria una pantalla que se puede abrir para
 * recibir seis rechazos.
 *
 * ES LA PRIMERA PANTALLA DE SIETE FUNCIONES DE `rep` que existian sin ninguna: tablero,
 * ejecucion_presupuesto, comparar_eventos, alertas_abiertas, y por la envoltura del boton,
 * consolidado_mensual y registrar_exportacion. Adjudicacion 191.
 */
export const rutaTablero = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/tablero',
  component: lazyRouteComponent(() => import('./tablero-pantalla.js'), 'RutaTablero'),
});
